import { PropTypes } from 'react';

import { DOCUMENT_TYPOLOGY } from '../utils/constants';
import IdNameEntity from './IdNameEntity';

export default class PopulationEntity {

  regions = [];
  agencies = [];
  functionGroups = [];
  userGroups = [];
  type;

  constructor(populationModel) {
    if (populationModel) {
      this.regions = populationModel.regions || [];
      this.agencies = populationModel.agencies || [];
      this.functionGroups = populationModel.functionGroups || [];
      this.userGroups = populationModel.userGroups || [];
      this.type = populationModel.type;
    }
  }

  get typology() {
    if (this.isNational()) {
      return DOCUMENT_TYPOLOGY.NATIONAL;
    }
    if (this.isRegional()) {
      return DOCUMENT_TYPOLOGY.REGIONAL;
    }
    if (this.isAgency()) {
      return DOCUMENT_TYPOLOGY.AGENCY;
    }
    return null;
  }

  get agencyIds() {
    return this.agencies.map(a => a.id);
  }

  get functionIds() {
    return this.functions.map(f => f.id);
  }

  get regionIds() {
    return this.regions.map(r => r.id);
  }

  isNational() {
    return this.type === 'criteria'
      && this.regions.length === 0
      && this.agencies.length === 0;
  }

  isRegional() {
    return this.type === 'criteria'
      && this.regions.length > 0
      && this.agencies.length === 0;
  }

  isAgency() {
    return this.type === 'criteria'
      && this.agencies.length > 0;
  }
}


PopulationEntity.Types = {
  CRITERIA: 'criteria',
  USER_GROUP: 'user_group',
};

PopulationEntity.shape = {
  type: PropTypes.oneOf([
    PopulationEntity.Types.CRITERIA,
    PopulationEntity.Types.USER_GROUP,
  ]),
  agencies: PropTypes.arrayOf(PropTypes.shape(IdNameEntity.shape)).isRequired,
  functionGroups: PropTypes.arrayOf(PropTypes.shape(IdNameEntity.shape)).isRequired,
  regions: PropTypes.arrayOf(PropTypes.shape(IdNameEntity.shape)).isRequired,
  userGroups: PropTypes.arrayOf(PropTypes.shape(IdNameEntity.shape)).isRequired,
};



// WEBPACK FOOTER //
// ./shared/src/entity/PopulationEntity.js